import { Grid, styled } from "@mui/material";

const ValueGrid = styled(Grid)({
    float: 'left',
    marginLeft: '1em'
});

export default ValueGrid;